import React, { ReactNode, MouseEvent } from 'react';
import { Button, IButtonProps } from '@grubhubprod/gh-cookbook-react';
import { useHistory } from 'react-router-dom';

export interface RouterButtonLinkProps {
  href: string;
  children: ReactNode;
  buttonVariant?: IButtonProps['variant']; // we could potentailly just expose all button prop types
  buttonSize?: IButtonProps['buttonSize'];
  isButtonDisabled?: boolean;
  useBlockButton?: boolean;
  preNavigationFunction?: () => void;
  className?: string;
}

export function RouterButtonLink({
  href,
  children,
  buttonVariant = 'primary',
  buttonSize = 'medium',
  useBlockButton = false,
  isButtonDisabled,
  preNavigationFunction,
  className,
}: RouterButtonLinkProps): JSX.Element {
  const { push } = useHistory();

  function runFunctionBeforeNavigation(
    event: MouseEvent<HTMLButtonElement>
  ): void {
    event.preventDefault(); // needed to prevent the Button's href from also triggering a 2nd route change

    // If the link is disabled, prevent further actions
    if (isButtonDisabled) {
      return;
    }

    if (preNavigationFunction) {
      preNavigationFunction();
    }

    push(href);
  }

  return (
    <Button
      as="a" // coudln't use as={RouterLink as React.ComponentType} since it messed up button styles, also button as type def only allows 'a | button'
      href={href} // this and as='a' needed to get open in new tab working
      variant={buttonVariant}
      block={useBlockButton}
      buttonSize={buttonSize}
      disabled={isButtonDisabled}
      onClick={runFunctionBeforeNavigation} // always executed to be the route change soure of truth, vs splitting ownership with the href prop
      className={className}
      style={{
        ...(isButtonDisabled ? { pointerEvents: 'none' } : {}),
      }}
    >
      {children}
    </Button>
  );
}
